module.exports = __webpack_public_path__ + "static/media/nqi-lite.4fd82949.jpg";